import React from 'react';
import { NavBar, Footer, CaseStudyHero, CaseStudyContent, CaseStudyTakeaway } from '../components';

const DeliverySystemCaseStudy = () => {

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <NavBar />
      <div className="flex-grow">
        <CaseStudyHero />
        <CaseStudyContent />
        <CaseStudyTakeaway />
      </div>
      <Footer />
    </div>
  );
};

export default DeliverySystemCaseStudy;